<template>
  <div class="sidebar-filters">
    <b-button class="text-uppercase" ref="escape" variant="reset-all" @click.prevent="resetFilters()">
      <i class="fas fa-eraser" /> {{ 'Reset all filters' | translate }}
    </b-button>
    <status-list-filter
      :default-status="1"
      @edit="editComponentFilters($event, 'filter__status__in')"
      @clean="cleanComponentFilters(['filter__status__in'])"
    />
    <work-status-choice-filter
      @edit="editComponentFilters($event, 'filter__work_status__in')"
      @clean="cleanComponentFilters(['filter__work_status__in'])"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { TYPES as YARD_TYPES } from './store'
import CommonFiltersMixin from '../../common-filters/CommonFiltersMixin'

export default {
  name: 'YardCommonFilters',
  mixins: [CommonFiltersMixin],
  computed: {
    ...mapGetters({
      filters: YARD_TYPES.GENERIC.yard.yard.LIST.GETTERS.filters
    })
  },
  methods: {
    ...mapActions({
      ...YARD_TYPES.GENERIC.yard.yard.LIST.ACTIONS
    })
  }
}
</script>
